/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_OrderInputs */

const en_flow_order = /** @type {(inputs: Flow_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An order`)
};

/**
* | output |
* | --- |
* | "An order" |
*
* @param {Flow_OrderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order = /** @type {((inputs?: Flow_OrderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_OrderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order(inputs)
});